import { Injectable } from '@angular/core';
import { AuthenticationService } from '@app/auth/services/authentication.service';
import { CommandDefinition, CommandHelper } from '@app/shared/quick-commands';

@Injectable({
  providedIn: 'root',
})
export class UserPermissionsCommand implements CommandDefinition<string> {
  icon = 'far fa-id-card';
  label = 'quickCommands.commands.permissions';
  name = 'permissions';

  constructor(private authenticationService: AuthenticationService) {}

  action() {
    return CommandHelper.list$(this.authenticationService.authUser$, (authUser) => {
      return {
        filterAutomatically: true,
        infoMessage: {
          parameters: {
            name: authUser.role.name,
          },
          key: 'quickCommands.commands.permissions.infoMessage',
        },
        placeholder: 'quickCommands.commands.permissions.placeholder',
        readonly: true,
        statusbar: {
          parameters: {
            total: authUser.role.permissions.length,
          },
          translationKey: 'quickCommands.commands.permissions.statusbar',
        },
        values: authUser.role.permissions
          .slice()
          .sort((a, b) => a.localeCompare(b))
          .map((permission) => {
            return {
              label: permission,
              value: permission,
            };
          }),
      };
    });
  }
}
